const config = require('../config.json');

export default {
  baseURL: config.baseURL,
  pageLimit: config.pageLimit,
  methods: ['GET', 'POST', 'PUT', 'DELETE', 'PATCH']
}